import CheckOutlined from '@ant-design/icons/lib/icons/CheckOutlined';
import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useStore } from '../../store';

interface ITimeStepsProps {
  steps: { title: string; link: string }[];
  // eslint-disable-next-line react/require-default-props
  current?: number;
}

export interface ICourseStep {
  title: string;
  link: string;
  state: 'active' | 'completed' | 'none';
}
interface ICourseStepsState {
  steps: ICourseStep[];
}

const TimeSteps: React.FunctionComponent<ITimeStepsProps> = ({
  steps,
  current = 0,
}) => {
  const [state, setState] = React.useState<ICourseStepsState>({ steps: [] });
  const navigate = useNavigate();
  const param = useParams();
  const p_course = param.course || '';
  const { getTopicState, language } = useStore();
  const topicState = getTopicState(p_course);
  React.useEffect(() => {
    setState({
      steps: steps.map((step, index) => ({
        ...step,
        state:
          topicState[index]?.state === 'completed'
            ? 'completed'
            : topicState[index]?.state === 'in-progress' || index === current
            ? 'active'
            : 'none',
      })),
    });
  }, [steps, current]);
  const gotoStep = (step: ICourseStep) => {
    navigate(`/${language}/course/${p_course}/${step.link}`);
    document?.querySelector('.course-body')?.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  };
  return (
    <div className="course-steps">
      {state.steps.map((step: ICourseStep) => (
        <div key={step.link} className={`step-item ${step.state}`}>
          <div
            className="step-dot"
            onClick={() => {
              if (step.state !== 'none') {
                gotoStep(step);
              }
            }}
          >
            {step.state === 'active' && <div className="active-dot" />}
            {step.state === 'completed' && (
              <div className="completed-dot">
                <CheckOutlined />
              </div>
            )}
          </div>
          <div className="step-title">{step.title}</div>
          <div className="step-line" />
        </div>
      ))}
    </div>
  );
};

export default TimeSteps;
